module.exports = __webpack_public_path__ + "img/yx1.6a9e4673.jpg";